import { ArrowRightOutlined } from '@ant-design/icons';
import { Alert, Button, Drawer } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../../../../AppContext';
import useRouteDrawer from '../../../../hooks/useRouteDrawer';
import useUltraPlanSubscriber from '../../../../hooks/useUltraPlanSubscriber';
import { getSubscriberLabel } from '../../../../ultraPlanUtils';
import ChildProfilesSection from './ChildProfilesSection';
import SubscriberOverview from './SubscriberOverview';

const SubscriberDrawer = ({ params, onClose, onOpenRoadmap }) => {
  const {
    state: { isDesktop },
  } = useContext(AppContext);
  const { isOpen, activeParams, getAfterOpenChange } = useRouteDrawer(params);
  const {
    subscription,
    isSubscriptionLoading,
    refetchSubscription,
    childProfiles,
    isChildProfilesLoading,
    hasChildProfilesError,
    refetchChildProfiles,
    isSubscriptionMismatch,
  } = useUltraPlanSubscriber(activeParams || {});

  return (
    <Drawer
      title={
        <div className="header-title">
          {subscription?.user
            ? getSubscriberLabel(subscription?.user)
            : 'Subscriber'}
        </div>
      }
      extra={
        <Button
          className="drawer-nav-button"
          onClick={() => onOpenRoadmap(activeParams)}
          disabled={!activeParams}
        >
          Open Roadmap
          <ArrowRightOutlined />
        </Button>
      }
      open={isOpen}
      onClose={onClose}
      afterOpenChange={getAfterOpenChange()}
      width={isDesktop ? '60%' : '100%'}
      className="custom-drawer ultra-plan-drawer"
      destroyOnClose
    >
      {activeParams && (
        <div className="ultra-plan-drawer-content">
          {isSubscriptionMismatch && (
            <Alert
              type="warning"
              showIcon
              message="This user's current subscription differs from the one this roadmap belongs to. The summary shows the current subscription."
            />
          )}
          <SubscriberOverview
            subscription={subscription}
            loading={isSubscriptionLoading}
            onDocumentSaved={refetchSubscription}
          />
          <ChildProfilesSection
            userSubscriptionId={activeParams?.userSubscriptionId}
            childProfiles={childProfiles}
            loading={isChildProfilesLoading}
            hasError={hasChildProfilesError}
            onRetry={refetchChildProfiles}
            onChanged={refetchChildProfiles}
          />
        </div>
      )}
    </Drawer>
  );
};

export default SubscriberDrawer;
